import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { lang } from '../services';

import Modal from './Modal';

const TermsModal = ({
    proxyName,
    onCloseTerms
}) => {
    return (
        <Modal
            className='TermsModal'
            onClose={onCloseTerms}
        >
            <div className='TermsModal__content'>
                {TERMS.map((term, key) => {
                    return (
                        <div key={`termsEl_${key}`} className={classNames('TermsModal__row', {
                            'TermsModal__row-bold': term.bold,
                            'TermsModal__row-uppercase': term.uppercase,
                            'TermsModal__row-paddingBottom': term.paddingBottom,
                        }
                        )}>
                            {lang.t(term.term, {PROXYNAME: proxyName})}
                        </div>
                    )
                })}
            </div>
        </Modal>
    );
}

const TERMS = [
    {
        term: "Terms of Service",
        bold: true,
        paddingBottom: true,
    },
    {
        term: "By using this website and our proxy servers (hereinafter referred to as \"{PROXYNAME}\", the \"Service\", \"we\", \"us\"), you agree to the following terms:",
        bold: true,
        paddingBottom: true,
    },
    {
        term: "1. Disclaimer of Warranties & Limitation of Liability",
    },
    {
        term: "1.1. The Service is provided \"as is\" without any express or implied warranties, including but not limited to merchantability, fitness for a particular purpose, and non-infringement.",
    },
    {
        term: "1.2. We shall not be liable for:",
        paddingBottom: true,
    },
    {
        term: "Any direct, indirect, incidental, or consequential damages arising from the use of the Service.",
        paddingBottom: true,
    },
    {
        term: "Inaccuracies, errors, or interruptions in third-party websites accessed through the Service.",
        paddingBottom: true,
    },
    {
        term: "The content of external resources, including malware, illegal material, or damages caused by their use.",
    },
    {
        term: "1.3. If you disagree with these terms, your sole remedy is to discontinue using the Service.",
        paddingBottom: true,
    },
    {
        term: "2. How the Proxy Service Works",
    },
    {
        term: "2.1. The Service acts as an intermediary between you and requested resources:",
        paddingBottom: true,
    },
    {
        term: "In a direct connection, you communicate with the target server directly.",
        paddingBottom: true,
    },
    {
        term: "When using {PROXYNAME}, requests are routed through our servers, and the target site does not see your IP address.",
    },
    {
        term: "2.2. We do not guarantee complete anonymity because:",
        paddingBottom: true,
    },
    {
        term: "Some resources (e.g., images, scripts) may load directly.",
        paddingBottom: true,
    },
    {
        term: "Delivered content may differ from the original (e.g., due to caching or modifications).",
        paddingBottom: true,
    },
    {
        term: "3. Lawful Use Only",
    },
    {
        term: "3.1. The Service may only be used for legal purposes. Prohibited activities include:",
        paddingBottom: true,
    },
    {
        term: "Distributing illegal content (piracy, malware, etc.).",
        paddingBottom: true,
    },
    {
        term: "Violating copyrights or intellectual property rights.",
        paddingBottom: true,
    },
    {
        term: "Spamming, phishing, or participating in DDoS attacks.",
        paddingBottom: true,
    },
    {
        term: "Actions violating laws in your jurisdiction or the target website’s jurisdiction.",
    },
    {
        term: "3.2. We reserve the right to block users for abuse (e.g., automated scraping, hotlinking, excessive server load).",
        paddingBottom: true,
    },
    {
        term: "4. Trademark",
    },
    {
        term: "4.1. The {PROXYNAME} name and logo are our intellectual property. Unauthorized use is prohibited.",
        paddingBottom: true,
    },
    {
        term: "5. Changes to Terms",
    },
    {
        term: "5.1. We may modify these terms at any time without prior notice. The current version will always be available on this site.",
    },
];

TermsModal.propTypes = {
    proxyName: PropTypes.string,
    onCloseTerms: PropTypes.func,
}

export default TermsModal;